module.exports = __webpack_public_path__ + "img/na-hradzi.6618fde1.png";